export default "__VITE_ASSET__BSghvzVG__"